import React from 'react';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';

import WorkshopDetails from './components/WorkshopDetails';
import ExperienceSection from './components/ExperienceSection';

import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App bg-gradient-to-b from-dream-light-beige via-dream-pink-beige to-dream-soft-beige min-h-screen">
      <HeroSection />
      <IntroSection />
      <AboutSection />
      <TestimonialsSection />

      <WorkshopDetails />
      <ExperienceSection />

      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
